<script setup lang="ts">
import { shortId } from '../utils/string';

defineProps({
    label: {
        type: String,
        default: ''
    },
    size: {
        type: String as PropType<'small' | 'large' | undefined>,
        default: undefined
    }
    
});

const inputId = ref(shortId());

</script>

<template>
    <label :for="inputId" style="user-select: none">
        <VLCheckbox
            :input-id="inputId"
            :size="size"
            binary
            class="mr-2"
            v-bind="$attrs"
        />
        {{ label }}
    </label>
</template>

